import styled from "styled-components";
import './style.css'
import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';


const DivBGtransparent = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  display: ${({ showModalAddObsItem }) => (showModalAddObsItem ? 'flex' : 'none')};
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  align-items: center;
  justify-content: center;
  opacity: ${({ showModalAddObsItem }) => (showModalAddObsItem ? '1' : '0')};
  transition: opacity 0.25s ease;
  animation: ${({ showModalAddObsItem }) => (showModalAddObsItem ? 'fadeIn 0.25s ease forwards' : 'none')};

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const DivContainer = styled.div`
    z-index: 10000;
    position: relative;
    width: 90%;
    max-width: 480px;
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    animation: modalSlideUp 0.3s ease;

    @keyframes modalSlideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
`;

const ModalAddObsItemCarrinho = ({
    itensCarrinho,
    showModalAddObsItem,
    setShowModalAddObsItem,
    setItensCarrinho,
    currentItem,
    setCurrentEditingItem
}) => {
    const { t } = useTranslation('cardapio');

    const closeModal = () => {    
        handleSaveObservation();    
        setShowModalAddObsItem(!showModalAddObsItem);
    }

    const [currentObservation, setCurrentObservation] = useState(currentItem?.observacoes_item || '');

    useEffect(() => {
        if (currentItem) {
            setCurrentObservation(currentItem.observacoes_item || '');
        }
    }, [currentItem]);

    const handleSaveObservation = () => {
        const updatedItems = itensCarrinho.map(item => {
            if (item.id === currentItem.id) {
                return { ...item, observacoes_item: currentObservation };
            }
            return item;
        });
        setItensCarrinho(updatedItems);
        localStorage.setItem('itensCarrinho', JSON.stringify(updatedItems));
        setShowModalAddObsItem(false);
        //setCurrentEditingItemId(null);
        setCurrentEditingItem(null); // Resetando o item que estava sendo editado.
    };
    
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    return (
        <DivBGtransparent showModalAddObsItem={showModalAddObsItem} onClick={handleBackdropClick}>
            <DivContainer>
                <div className="divTitleItemAdicionado">
                    <span className="divTitleItemAdicionadoSpan">{t('modal.observation.title')}</span> 
                </div>

              
                <div className="obsTextBoxContainerModalAddItem">
                    <div className="obsTextBoxData">
                        <textarea placeholder={t('modal.observation.placeholder')} 
                            value={currentObservation}
                            onChange={e => setCurrentObservation(e.target.value)}
                            maxLength="200"
                            className="text-areaObs"
                        />
                        <div className="divCounterChar">{currentObservation.length}/200</div>               
                    </div>
                </div>
          

                <div className="divBtnContinueCart">
                    {/*<button className="buttonContinue" onClick={()=> closeModal()}>Não preciso de troco</button>*/}
                    <div style={{width:'100%'}}>
                        <button className="buttonCart" onClick={() => closeModal()}>{t('modal.observation.confirm')}</button>
                    </div>
                </div>

            </DivContainer>
        </DivBGtransparent>
    );
}

export default ModalAddObsItemCarrinho;